module.exports = __webpack_public_path__ + "static/media/intro-cloud.b0e3298a.svg";